export default function filterBiddingLossReasonsData(data = [], filters = {}) {
  const {
    year = new Date().getFullYear(),
    month = '',
    stateSelecionado = '',
    biddingTypeSelecionado = '',
  } = filters

  function isDateInYearAndMonth(dateStr) {
    if (!dateStr) return false
    const date = new Date(dateStr)
    if (Number.isNaN(date.getTime())) return false
    const yearOk = date.getFullYear() === Number(year)
    const monthOk = month ? (date.getMonth() + 1) === Number(month) : true
    return yearOk && monthOk
  }

  const filteredData = data.filter(item => {
    if (!isDateInYearAndMonth(item.date)) return false
    if (stateSelecionado && item.stateName !== stateSelecionado) return false
    if (biddingTypeSelecionado && item.biddingType !== biddingTypeSelecionado) return false
    return true
  })

  const normalizationMap = {
    SEMINTERESSE: 'SEM INTERESSE',
    NAOPARTICIPOU: 'NÃO PARTICIPOU',
    NAOGANHOU: 'NÃO GANHOU',
    DESCLASSIFICADO: 'DESCLASSIFICADO',
  }

  const phasesCount = {
    'SEM INTERESSE': 0,
    'NÃO PARTICIPOU': 0,
    'NÃO GANHOU': 0,
    DESCLASSIFICADO: 0,
  }

  filteredData.forEach(item => {
    const rawPhase = (item.phase || item.phase_Name || '').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    const cleanPhase = rawPhase.replace(/\s+/g, '')

    const mappedPhase = normalizationMap[cleanPhase]
    if (mappedPhase && Object.prototype.hasOwnProperty.call(phasesCount, mappedPhase)) {
      phasesCount[mappedPhase] += 1
    }
  })

  return {
    labels: Object.keys(phasesCount),
    datasets: [
      {
        label: 'Quantidade de Oportunidades',
        backgroundColor: ['#f44336', '#ff9800', '#03a9f4', '#9c27b0'],
        data: Object.values(phasesCount),
      },
    ],
  }
}
